var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasContent
    ? _c(
        "div",
        { staticClass: "reporting-section" },
        [
          _c("div", { staticClass: "section-header" }, [
            _c("i", { staticClass: "material-icons section-icon" }, [
              _vm._v("videocam"),
            ]),
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("dash.reporting.section.videos.title"))),
            ]),
          ]),
          _vm.kpis.length
            ? _c(
                "div",
                { staticClass: "metric-row" },
                _vm._l(_vm.kpis, function (k) {
                  return _c("MetricCard", {
                    key: k.key,
                    attrs: {
                      value: k.value,
                      "previous-value": k.prev || null,
                      label: k.label,
                      icon: k.icon,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm.videoGraphSources.length && _vm.videoGraphLabels.length
            ? [
                _c("div", { staticClass: "graph-title" }, [
                  _vm._v("Sources de vues"),
                ]),
                _c(
                  "div",
                  { staticClass: "graph-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `video-sources-${_vm.pageId}`,
                        data: _vm.videoGraphSources,
                        labels: _vm.videoGraphLabels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.videoGraphBehavior.length && _vm.videoGraphLabels.length
            ? [
                _c("div", { staticClass: "graph-title" }, [
                  _vm._v("Comportement de lecture"),
                ]),
                _c(
                  "div",
                  { staticClass: "graph-wrap" },
                  [
                    _c("Graph", {
                      attrs: {
                        id: `video-behavior-${_vm.pageId}`,
                        data: _vm.videoGraphBehavior,
                        labels: _vm.videoGraphLabels,
                        height: "200px",
                        width: "100%",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.videoPosts.length
            ? [
                _c("div", { staticClass: "video-table-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("dash.reporting.section.videos-list.title"))
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "post-table" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "post-table__head",
                        style: { gridTemplateColumns: _vm.gridTemplate },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "col-header sortable",
                            class: _vm.sortClass("date"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("date")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(
                                    _vm.$t("dash.reporting.pdf.listItem.date")
                                  )
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("date")))]
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "col-header" }, [
                          _vm._v(
                            _vm._s(
                              _vm.cap(
                                _vm.$t(
                                  "dash.reporting.pdf.listItem.publication"
                                )
                              )
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("views"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("views")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(_vm.$t("dash.label.fb.video_views"))
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("views")))]
                            ),
                          ]
                        ),
                        _vm.network === "facebook"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("views15s"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("views15s")
                                  },
                                },
                              },
                              [
                                _vm._v("\n          Vues 15s"),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("views15s")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.network === "tiktok"
                          ? _c(
                              "span",
                              { staticClass: "col-header align-right" },
                              [_vm._v("Temps vu")]
                            )
                          : _vm._e(),
                        _vm.network === "tiktok"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("finish"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("finish")
                                  },
                                },
                              },
                              [
                                _vm._v("\n          % complétion"),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("finish")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.network === "tiktok"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("viewer"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("viewer")
                                  },
                                },
                              },
                              [
                                _vm._v("\n          Spectateurs"),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("viewer")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.network === "tiktok"
                          ? _c(
                              "span",
                              { staticClass: "col-header align-right" },
                              [_vm._v("Moy. durée")]
                            )
                          : _vm._e(),
                        _vm.network === "tiktok"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("newFollower"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("newFollower")
                                  },
                                },
                              },
                              [
                                _vm._v("\n          Nvx abonnés"),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("newFollower")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.network === "instagram"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("reach"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("reach")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.cap(
                                        _vm.$t(
                                          "dash.label.fb.impressions_reach"
                                        )
                                      )
                                    )
                                ),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("reach")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("reactions"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("reactions")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(_vm.$t("dash.reporting.reaction"))
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("reactions")))]
                            ),
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("comments"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("comments")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(_vm.$t("dash.reporting.comment"))
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("comments")))]
                            ),
                          ]
                        ),
                        _vm.network !== "tiktok"
                          ? _c(
                              "span",
                              {
                                staticClass: "col-header sortable align-right",
                                class: _vm.sortClass("shares"),
                                on: {
                                  click: function ($event) {
                                    return _vm.onSort("shares")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.cap(_vm.$t("dash.reporting.share"))
                                    )
                                ),
                                _c(
                                  "i",
                                  { staticClass: "material-icons sort-icon" },
                                  [_vm._v(_vm._s(_vm.sortIcon("shares")))]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "col-header sortable align-right",
                            class: _vm.sortClass("engagement"),
                            on: {
                              click: function ($event) {
                                return _vm.onSort("engagement")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.cap(
                                    _vm.$t(
                                      "dash.reporting.pdf.listItem.engagement"
                                    )
                                  )
                                )
                            ),
                            _c(
                              "i",
                              { staticClass: "material-icons sort-icon" },
                              [_vm._v(_vm._s(_vm.sortIcon("engagement")))]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._l(_vm.paginatedPosts, function (post) {
                      return _c(
                        "div",
                        {
                          key: post.id || post.post_id,
                          staticClass: "post-table__row",
                          style: { gridTemplateColumns: _vm.gridTemplate },
                        },
                        [
                          _c("span", { staticClass: "cell-date" }, [
                            _vm._v(_vm._s(_vm.fmtDate(post.created_time))),
                          ]),
                          _c("div", { staticClass: "cell-post" }, [
                            _c("div", { staticClass: "post-thumb" }, [
                              post.attachment_url
                                ? _c("img", {
                                    attrs: {
                                      src: post.attachment_url,
                                      alt: "",
                                    },
                                  })
                                : _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("videocam"),
                                  ]),
                            ]),
                            _c("p", { staticClass: "post-msg" }, [
                              _vm._v(_vm._s(post.message)),
                            ]),
                          ]),
                          _c("span", { staticClass: "cell-num" }, [
                            _vm._v(_vm._s(_vm.fmt(_vm.viewsFor(post)))),
                          ]),
                          _vm.network === "facebook"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.fmt(post.video_view_count_15s || 0)
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.network === "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(_vm._s(_vm.fmtTime(post.time_watched))),
                              ])
                            : _vm._e(),
                          _vm.network === "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(
                                  _vm._s(
                                    post.video_finish_rate != null
                                      ? post.video_finish_rate.toFixed(1) + "%"
                                      : "—"
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.network === "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(
                                  _vm._s(
                                    post.viewer != null
                                      ? _vm.fmt(post.viewer)
                                      : "—"
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.network === "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(
                                  _vm._s(_vm.fmtTime(post.video_per_duration))
                                ),
                              ])
                            : _vm._e(),
                          _vm.network === "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(
                                  _vm._s(
                                    post.video_new_follower != null
                                      ? _vm.fmt(post.video_new_follower)
                                      : "—"
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _vm.network === "instagram"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(_vm._s(_vm.fmt(post.reach || 0))),
                              ])
                            : _vm._e(),
                          _c("span", { staticClass: "cell-num" }, [
                            _vm._v(_vm._s(_vm.fmt(_vm.reactionsFor(post)))),
                          ]),
                          _c("span", { staticClass: "cell-num" }, [
                            _vm._v(_vm._s(_vm.fmt(post.comments_count || 0))),
                          ]),
                          _vm.network !== "tiktok"
                            ? _c("span", { staticClass: "cell-num" }, [
                                _vm._v(_vm._s(_vm.fmt(post.shares_count || 0))),
                              ])
                            : _vm._e(),
                          _c("span", { staticClass: "cell-num" }, [
                            _vm._v(
                              _vm._s(
                                post.reach_engagement
                                  ? post.reach_engagement.toFixed(2) + "%"
                                  : "—"
                              )
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
                _vm.pageCount > 1
                  ? _c("div", { staticClass: "pagination" }, [
                      _c(
                        "button",
                        {
                          staticClass: "page-btn",
                          attrs: { disabled: _vm.currentPage === 1 },
                          on: {
                            click: function ($event) {
                              _vm.currentPage--
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("chevron_left"),
                          ]),
                        ]
                      ),
                      _c("span", { staticClass: "page-info" }, [
                        _vm._v(
                          _vm._s(_vm.currentPage) +
                            " / " +
                            _vm._s(_vm.pageCount)
                        ),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "page-btn",
                          attrs: {
                            disabled: _vm.currentPage === _vm.pageCount,
                          },
                          on: {
                            click: function ($event) {
                              _vm.currentPage++
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("chevron_right"),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }